import { MODAL_OPEN, MODAL_CLOSE, MODAL_INIT, INIT_MODAL_CALLBACK, CLEAR_MODAL_CALLBACK } from '../actions/index';

const commonProcess = (state, action) => {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        ...state,
        modalStatus: true,
        modalMessage: action.commonParams.modalMessage,
        modalRedirect: action.commonParams.modalRedirect
      }
    case MODAL_CLOSE:
      return {
        ...state,
        modalStatus: false,
        modalMessage: null,
        modalRedirect: action.commonParams.modalRedirect
      }  
    case MODAL_INIT:
      return {
        ...state,
        modalStatus: false,
        modalMessage: null,
        modalRedirect: null
      }  
    case INIT_MODAL_CALLBACK:
      return {
        ...state,
        callback: action.commonParams.callback
      }
    case CLEAR_MODAL_CALLBACK:
      return {
        ...state,
        callback: null
      }
    default:
      return state;
    }
}

const commonReducers = (state = {
    modalStatus: false,
    modalMessage: null,
    modalRedirect: null,
    callback: null
}, action) => {
  switch (action.type) {
    default:
      return commonProcess(state, action);
  }
}

export default commonReducers;